/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, Space, Table, Tooltip, Typography } from 'antd';
import React, { useState } from 'react';
import moment from 'moment';
import './other-incident.scss';
import { FlagFilled } from '@ant-design/icons';
import {
  EFilterResponseStatusIncidents,
  IPayloadLoadingOtherIncidents,
} from 'pages/incidents/interfaces';
import { loadingOtherIncidentsAction } from 'actions/incidents';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router';
import { translate } from 'libs';
interface IOtherIncidentByUserProps {
  isVisible: boolean;
  onCancel: () => void;
  deviceUserId: string;
}

const OtherIncident = ({ isVisible, onCancel, deviceUserId }: IOtherIncidentByUserProps) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataSource, setDataSource] = React.useState<any[]>([]);

  const getIncident = React.useCallback(() => {
    setIsLoading(true);
    const payload: IPayloadLoadingOtherIncidents = {
      device_user_id: deviceUserId,
      onSuccess: (data: any) => {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
        if (Array.isArray(data)) {
          setDataSource(data);
        }
      },
      onError: (errorCode: string) => {
        console.log('🚀 ~ errorCode', errorCode);
        setIsLoading(false);
      },
    };

    return dispatch(loadingOtherIncidentsAction(payload));
  }, [deviceUserId]);

  React.useEffect(() => {
    if (isVisible) {
      getIncident();
    }

    return () => {
      setDataSource([]);
    };
  }, [isVisible]);

  const [sortType, setSortType] = React.useState<string>('');
  const [ascOrder, setAscOrder] = React.useState<boolean>(true);

  const handleClickSorter = (type) => {
    if (sortType === type) {
      if (ascOrder === false) {
        setSortType('');
      } else {
        setAscOrder(!ascOrder);
      }
    } else {
      setSortType(type);
      setAscOrder(true);
    }
  };

  const columns: any = [
    {
      title: () => {
        return (
          <div onClick={() => handleClickSorter('sequence')} className="table-header">
            <span
              className={
                sortType === 'sequence' ? (ascOrder === true ? 'upIcon' : 'downIcon') : 'normalIcon'
              }
            >
              {translate('incidents.list.incident')}
            </span>
          </div>
        );
      },
      dataIndex: 'sequence',
      width: 130,
      className: 'incident-sequence',
      showSorterTooltip: false,
      ellipsis: {
        showTitle: false,
      },
      align: 'center',
      sorter: (a: any, b: any) => a.sequence - b.sequence,
      render: (sequence: number) => (
        <Tooltip placement="bottomLeft" title={sequence}>
          <Typography.Text className="txt-incident">{sequence}</Typography.Text>
        </Tooltip>
      ),
    },
    {
      title: translate('incidents.list.msgs'),
      dataIndex: 'totalMessage',
      width: 96,
      render: (totalMessage: number, record: any) => {
        let src: string = '';
        let tooltip: string = '';
        switch (record?.response_status) {
          case EFilterResponseStatusIncidents.READ_ANSWERED:
            src = '/images/ic-read-anwered.png';
            tooltip = 'readAndAnwered';
            break;
          case EFilterResponseStatusIncidents.READ_UNANSWERED:
            src = '/images/ic-read-unanwered.png';
            tooltip = 'readAndUnanwered';
            break;
          case EFilterResponseStatusIncidents.UNREAD:
            if (totalMessage > 0) {
              src = '/images/ic-unread-dot.png';
            } else {
              src = '/images/ic-unread.png';
            }
            tooltip = 'unread';
            break;
          default:
            break;
        }
        return (
          <Space>
            {src && (
              <Tooltip placement="bottomLeft" title={translate(`incidents.list.${tooltip}`)}>
                <img alt="" src={src} />
              </Tooltip>
            )}
            <Typography.Text>{totalMessage || 0}</Typography.Text>
          </Space>
        );
      },
    },
    {
      title: translate('incidents.list.status'),
      dataIndex: 'status',
      width: 140,
      ellipsis: {
        showTitle: false,
      },
      render: (status: any) => {
        return (
          <Tooltip placement="bottomLeft" title={status?.name}>
            <Typography.Text>{status?.name}</Typography.Text>
          </Tooltip>
        );
      },
    },
    {
      title: translate('incidents.list.description'),
      dataIndex: 'description',
      width: 320,
      ellipsis: {
        showTitle: false,
      },
      render: (record: string) => (
        <Tooltip placement="bottomLeft" title={record}>
          {record}
        </Tooltip>
      ),
    },
    {
      title: translate('incidents.list.org'),
      dataIndex: 'organization',
      width: 300,
      ellipsis: {
        showTitle: false,
      },
      render: (_: any, record: any) => {
        const orgName: string | null = record?.org_id?.name;
        return (
          <Tooltip placement="bottomLeft" title={orgName}>
            {orgName}
          </Tooltip>
        );
      },
    },
    {
      title: () => {
        return (
          <div onClick={() => handleClickSorter('updatedAt')} className="table-header">
            <span
              className={
                sortType === 'updatedAt'
                  ? ascOrder === true
                    ? 'upIcon'
                    : 'downIcon'
                  : 'normalIcon'
              }
            >
              {translate('incidents.list.updated')}
            </span>
          </div>
        );
      },
      dataIndex: 'updatedAt',
      width: 120,
      sorter: (a: any, b: any) => moment(a.updatedAt).unix() - moment(b.updatedAt).unix(),
      showSorterTooltip: false,
      ellipsis: {
        showTitle: false,
      },
      render: (record: string) => {
        const text: string = moment(record).format('YYYY/MM/DD');
        return (
          <Tooltip placement="bottomLeft" title={text}>
            {text}
          </Tooltip>
        );
      },
    },
    {
      title: () => {
        return (
          <div onClick={() => handleClickSorter('createdAt')} className="table-header">
            <span
              className={
                sortType === 'createdAt'
                  ? ascOrder === true
                    ? 'upIcon'
                    : 'downIcon'
                  : 'normalIcon'
              }
            >
              {translate('incidents.list.submitted')}
            </span>
          </div>
        );
      },
      dataIndex: 'createdAt',
      width: 120,
      sorter: (a: any, b: any) => moment(a.createdAt).unix() - moment(b.createdAt).unix(),
      showSorterTooltip: false,
      ellipsis: {
        showTitle: false,
      },
      render: (record: string) => {
        const text: string = moment(record).format('YYYY/MM/DD');
        return (
          <Tooltip placement="bottomLeft" title={text}>
            {text}
          </Tooltip>
        );
      },
    },
    {
      title: translate('incidents.list.priority'),
      dataIndex: 'priority',
      align: 'center',
      ellipsis: {
        showTitle: false,
      },
      render: (priority: any) => {
        if (!priority || !priority.color) {
          return null;
        }
        return (
          <Tooltip placement="bottomLeft" title={priority?.name}>
            {priority?.color ? <FlagFilled style={{ color: priority?.color }} /> : null}
          </Tooltip>
        );
      },
    },
  ];

  const withLink = (columnConfig, record) => {
    if (!columnConfig) {
      return null;
    }

    const originalRender = columnConfig.render || ((text) => text);
    const url = `/admin/incidents/${record._id}`;

    return {
      ...columnConfig,
      render: (text, record, index) => {
        const cellContent = originalRender(text, record, index);
        return (
          <a 
            href={url} 
            onClick={(e) => {
              e.stopPropagation(); 
            }}
            style={{ 
              display: 'block',
              color: 'inherit',
              textDecoration: 'none'
            }}
          >
            {cellContent}
          </a>
        );
      },
    };
  };

  return (
    <Modal
      title={translate('settingPage.deactivatedUser.otherIncident')}
      centered
      visible={isVisible}
      maskClosable={false}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" className="btn-close" size="large" onClick={onCancel}>
          {translate('incidents.other_incident.close')}
        </Button>,
      ]}
      className="modal md-other-incident-user"
      width={1366}
    >
        <Table
          columns={columns.map((col) => ({
          ...col,
          render: (text, record, index) => {
            const linkedColumn = withLink(col, record);
            return linkedColumn.render(text, record, index);
          }
          }))}
          dataSource={dataSource}
          pagination={false}
          className="table-other-incident-user"
          onRow={(item: any, index: any) => ({
            className: index % 2 === 0 ? 'row-odd' : '',
          })}
          rowKey="_id"
          loading={isLoading}
          scroll={{ y: 'calc(100vh - 290px)' }}
          locale={{ emptyText: translate('no_data', { name: translate('list.empty.incident') }) }}
        />
      
    </Modal>
  );
};

export default React.memo(OtherIncident);
